// const API_SERVICE = "http://localhost:5000";
const API_SERVICE = "https://hopproductionserver.herokuapp.com";
const SECRET_KEY = "realestateofficial2020";

export { API_SERVICE, SECRET_KEY };
